// export const uri ='http://srv801875.hstgr.cloud:8888/api/'
// export const uri ='https://srv801875.hstgr.cloud/api'
// export const uri ='http://localhost:8080/api'
export const uri ='https://srv801875.hstgr.cloud/api'
